/**
 * The constraints a widget has to respect when resolving their layout. A
 * 4-tuple containing, respectively, minimum width, maximum width, minimum
 * height and maximum height.
 *
 * @category Core
 */
export type LayoutConstraints = [minWidth: number, maxWidth: number, minHeight: number, maxHeight: number];
